
import {hideXWMenu,isWeiXin} from '../../api/showWXmenu.js';
import {EncryptString} from '../../../static/js/xintong/AESUtils.js'
import XButton from 'vux/src/components/x-button/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Toast from 'vux/src/components/toast/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import {fetch,promptMessage} from '@/api/dataHandling';
import {urlConfig} from '@/api/urlConfig';
import {getken} from '@/api/getToken';
import peitaiImg from './images/peitai.png';
import xufeiImg from './images/xufei.png';
export default {
data(){
return {
lipinList:[],
peitaiImg,
xufeiImg,
tabindex:0,
EncryptString,
toastMsg:'',
toastValue:false,
confirmshow:false,
shoppingcard:0,
formData:{
patientName:'',
identityNo:'',
score:'',
},
hosCode:'',
personInfoId:'',
Mypoints:'',
toalMypoints:'',
xm:'',
sfzh:'',
openid:'',
integralDisabled:false
}
},
directives: {
TransferDom
},
components: {
XButton,Tab, TabItem,Toast,XInput,Group,Confirm,Cell,Grid, GridItem,XHeader,XDialog
},
methods:{
cardClick(item){
this.$router.push({path:'/integralMallDetail',query:{openid:this.openid,personInfoId:this.personInfoId,Mypoints:this.Mypoints,goodsid:item.goodsid,title:item.title,xm:this.xm,sfzh:this.sfzh,hosCode:this.hosCode}});
},
numberyanzheng(obj){
this.$nextTick(function () {
if(obj == 'identityNo'){


}else if(obj == 'score'){
this.formData[obj] = (this.formData[obj]).replace(/[^\d]/g, '').trim();
if(this.Mypoints <this.formData[obj]){
this.toastValue = true;
this.toastMsg = '可用积分小于对转赠积分';
this.formData[obj] ='';
}
if(this.formData[obj]==0){
this.formData[obj] ='';
}
}


});
},
getUserId(){
this.$store.commit('updateLoadingStatus',{isLoading:true});
fetch('post',urlConfig.GetSfzh +'?openid='+this.$route.query.openid).then(response => {
this.sfzh = response.sfzh;
this.xm = response.xm;
this.getPersonInfoId(response.sfzh);
}).catch(error => {

})
},
getPersonInfoId(sfzh){
fetch('post',urlConfig.jifenGetPersonInfoId +'?sfzh='+sfzh).then(response => {
this.personInfoId = response.personInfoId;
this.getMypoints(this.personInfoId);
this.getShoppingCard(this.personInfoId);
}).catch(error => {
})

},
getMypoints(id){
fetch('post',urlConfig.jifenIntegral +'?personInfoId='+id).then(response => {
this.Mypoints = response.totalYdjJifen;  
this.toalMypoints = response.syTotalJifen;  
this.$store.commit('updateLoadingStatus',{isLoading:false})
}).catch(error => {

})
},  //获取积分
getShoppingCard(id) {
fetch('post',urlConfig.getShoppingCard +'?personInfoId='+id+'&gzhArea='+this.hosCode).then(response => {
this.lipinList =[];
console.log(response,33333)
for(let i=0;i<response.length;i++){
this.lipinList.push({
txt:response[i].shopDisplayName,
img:response[i].indexImage,
detailImg:response[i].detailImage,
title:response[i].shopDisplayName,
points:response[i].goodsPrice,
goodsid:response[i].goodsId,
goodsNum:response[i].goodsNum
})
}

}).catch(error => {

})
},
mallClick(url){
this.$router.push({ path:url});
},
submit(){

let submitParam = new URLSearchParams();
submitParam.append('srcPersonInfoId',this.personInfoId);
submitParam.append('destPersonInfoId',this.givepersonInfoId);
submitParam.append('score',this.formData.score);
fetch('post',urlConfig.getgivejifenSave,submitParam).then(response => {
this.confirmshow = false;
promptMessage('提示','赠送成功！')
this.$store.commit('updateLoadingStatus',{isLoading:false})
/*          document.getElementsByClassName('integralMallzdy-dialog')[0].childNodes[0].childNodes[2].style.zIndex = 5000;*/
this.integralDisabled = false;
}).catch(error => {
/*     document.getElementsByClassName('integralMallzdy-dialog')[0].childNodes[0].childNodes[2].style.zIndex = 5000;*/
this.$store.commit('updateLoadingStatus',{isLoading:false})
this.toastValue = true;
this.toastMsg = error;
this.integralDisabled = false;
})
},
getGivePersoninfor(){
this.$store.commit('updateLoadingStatus',{isLoading:true});
let param = new URLSearchParams();
param.append("patientName",this.formData.patientName);
param.append("identityNo",this.formData.identityNo);
fetch('post',urlConfig.getgivepersoninfor,param).then(response => {
if(typeof response.data === 'undefined'){ //输入正确
this.givepersonInfoId = response;
/*    document.getElementsByClassName('integralMallzdy-dialog')[0].childNodes[0].childNodes[2].style.zIndex = 999;*/
this.submit();

}else if(response.data === null){ //输入有误
this.toastValue = true;
this.toastMsg = '卡号或姓名有误';
this.$store.commit('updateLoadingStatus',{isLoading:false})
this.integralDisabled = false;
}

}).catch(error => {
this.toastValue = true;
this.toastMsg = error;
this.$store.commit('updateLoadingStatus',{isLoading:false})
this.integralDisabled = false;
})
},
giveConfirm(){
for(let i in this.formData){
this.formData[i] = this.formData[i].trim();
}

if(this.formData.patientName !='' && this.formData.identityNo !='' &&this.formData.score !=''){  //提交
this.integralDisabled = true;
this.getGivePersoninfor();
}else{
if(this.formData.score ==''){

this.toastMsg = '请输入赠送积分';
}else{

this.toastMsg = '请输入姓名和卡号';
}
this.toastValue = true;

}
},
giveHide(){
for(let i in this.formData){
this.formData[i] = '';
}
},
getpersoninfor(){
fetch('post',urlConfig.patientBasicInfosGet+'?personInfoId=' + this.personInfoId).then(res => {  //获取患者openid
this.sfzh = res.idCard;
this.xm = res.patientName;
}).catch(error => {

});
this.getMypoints(this.personInfoId);
this.getShoppingCard(this.personInfoId);
}

},
mounted(){

if(!this.$route.query.hosCode){
this.hosCode ='420100000002';
}else{
this.hosCode =this.$route.query.hosCode;
}
this.openid = this.$route.query.openid;
getken(this.getUserId);
hideXWMenu(this.$route.query.openid);
isWeiXin();


this.$nextTick(function(){
$('.inputClick').on('click',function(){
$(this).find('input').focus();
})
})

}
}



// WEBPACK FOOTER //
// ./src/project/integralMallProject/integralMallCS.vue